import React from 'react'
import { Button } from 'semantic-ui-react'
import { Card, CardHeader, CardContent, Collapse } from '@material-ui/core';
import { ActionContainer, Cont } from './styled'

const StdCard = (props) => {
  const { 
    title='title', 
    children, 
    accessoriesHeader=null,
    style={},
    enableCollapse=true,
    highlight=false,
    hideHeader=false,
    defaultExpand=true,
    flexZero=false
  } = props
  const [expand, setExpand] = React.useState(defaultExpand)

  return (
    <Cont flexZero={flexZero}>
    <Card style={{ ...style, boxShadow: highlight ? '0px 0px 5px 1px #FBBF66' : 'inherit' }}>
      {
        !hideHeader ?
          <CardHeader
          title={title}
          action={
            <ActionContainer>
              {accessoriesHeader}
              <div className='cardHeaderActions'>
                { expand ? 
                  <Button type='button' className={enableCollapse ? '' : 'hiddenButton'} size='mini' circular icon='chevron up' onClick={() => setExpand(false)} /> : 
                  <Button type='button' className={enableCollapse ? '' : 'hiddenButton'} size='mini' circular icon='chevron down' onClick={() => setExpand(true)} />
                }
              </div>
            </ActionContainer>
          }
        /> : null
      }
      <Collapse in={expand}>
        <CardContent>
          {children}
        </CardContent>
      </Collapse>
    </Card>
    </Cont>
  )
}

export default StdCard